module.exports = __webpack_public_path__ + "static/media/sk.12f5803d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sk.svg
// module id = 2208
// module chunks = 0